import React from "react";
import { CheckBoxComp,ErrorTextComp } from "./../../../inputs/fields.component";
import GoalServices from "./../../../../services/goal.services";
import PermissionComp from "./permission.component";
import { reactLoader, removeReactLoader, constructNestedKRPayload } from "../../../../utils/common.js";
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import RetainUpdateModal from '../../../../components/retainUpdateModal.component';
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import { withTranslation } from "react-i18next";
import NestedInlineComp from "./NestedInline.component";
import AddKrTag from "../../../../krTags/components/addkrTag.component"
import { ThemeProvider, Checkbox } from '@workboard/wobo-ui';
import styled from 'styled-components';
import Customokr from './../../../custom_fields/customobj/Customokr';
import KrRelationshipWrapper from "./krRelationshipWrapper";
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';

const StyledCheckbox = styled(Checkbox)`
  .MuiButtonBase-root {
    width: 24px;
    height: 24px;
    margin-left: -5px;
  }
  input{
    display: inline-block !important;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;
class AsanaPostLogin extends React.Component {
	constructor(props) {
		super(props);
		const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		this.state = {
			asanaRepoData: [],
			asanaProjIds: this.props.item.asanaProjIds ? this.props.item.asanaProjIds : [],
			errors: [],
			asanaProjNames: {},
			teamPermissionSelected:
				this.props.item && this.props.item.permission_teams
					? this.props.item.permission_teams
					: [],
			bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
			permissionHelpPopUp: false,
			permissionstate:
				this.props.item && this.props.item.permission
					? this.props.item.permission.split(",").map(Number)
					: this.props.goalDetails.type == 1 ? [8] : [10],
			confirmPopup: false,			
			externalSource: false,
			titleRetain: "",
			contentRetain: "",
			krAlingSelected: this.props.item &&
					this.props.item.kr_aligns !== undefined &&
					this.props.item.kr_aligns.length > 0
					? this.props.item.kr_aligns
					: [],
			krDependenciesSelected: this.props.item &&
					this.props.item.kr_dependent !== undefined &&
					this.props.item.kr_dependent.length > 0
					? this.props.item.kr_dependent
					: [],
			tags:[],
			selectedType:'',
			exclude: this.props.item && this.props.kpiType == "asa" && this.props.item.ext_app_id == 6 &&
					(this.props.item.progress_consider == 0 || this.props.item.progress_consider == false) ? true : false,
			nplTags:this.props.nplTags ? this.props.nplTags : [],
			selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
			selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
			tagsList:this.props.tagsList ? this.props.tagsList:[],
			isCustomSave:[],
			customInputData:[], 
			coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : []
		};
		this.GoalServices = new GoalServices();
		this.changeRepoSelection = this.changeRepoSelection.bind(this);
		this.validateAsanaKr = this.validateAsanaKr.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.permissionData = this.permissionData.bind(this);
		this.teamPermissionData = this.teamPermissionData.bind(this);
		this.exitDeleteModal = this.exitDeleteModal.bind(this);
		this.saveItems = this.saveItems.bind(this);
		this.saveAlignArr = this.saveAlignArr.bind(this);
		this.saveDependentArr = this.saveDependentArr.bind(this);
		this.changeRadio = this.changeRadio.bind(this);
		this.handleExcludeChange = this.handleExcludeChange.bind(this);
		this.updateTags = this.updateTags.bind(this);
		this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
		this.renderError = this.renderError.bind(this);

		this.validateAsanaKrCompleted = this.validateAsanaKrCompleted.bind(this);
	}

	componentWillUnmount() {
		this.props.kpiRef(null)
	}

	componentDidMount() {
		let _this = this;
		let metricId = -1;
		if (this.props.item && this.props.item.id) {
			metricId = this.props.item.id;
		}
		this.props.kpiRef(this)
		reactLoader(true);
		this.GoalServices.getExtProjects({
			app: "asana",
			metricId: metricId
		}).then(function (response) {
			removeReactLoader();
			if (response && response.data && response.data.data) {
				let exisProjIds = _this.state.asanaProjIds;
				if (
					response.data.mapping &&
					response.data.mapping.metric_projects &&
					metricId
				) {
					exisProjIds = response.data.mapping.metric_projects[metricId];
				}

				//update existing project names
				let projNames = {};
				if (exisProjIds.length > 0) {
					exisProjIds.map((item, index) => {
						let findVal = response.data.data.find(st => st.project_id === item);
						projNames[item] = findVal.project_name;
					});
				}

				_this.setState({
					asanaRepoData: response.data.data,
					asanaProjIds: exisProjIds,
					asanaProjNames: projNames
				});
			}
		});
	}

	changeRepoSelection(e, item) {
		let existingProjIds = this.state.asanaProjIds;
		let existingProjNames = this.state.asanaProjNames;
		if (e.target.checked == true) {
			existingProjIds.push(item.project_id);
			existingProjNames[item.project_id] = item.project_name;
		} else {
			let projInd = existingProjIds.indexOf(item.project_id)
			if (projInd > -1) {
				existingProjIds.splice(projInd, 1);
				delete existingProjNames[item.project_id];
			}
		}
		this.setState({
			asanaProjIds: existingProjIds,
			asanaProjNames: existingProjNames
		});
	}

	permissionData(perData) {
		this.setState({
			permissionstate: perData
		});
	}

	teamPermissionData(teamPerData) {
		this.setState({
			teamPermissionSelected: teamPerData
		});
	}

	bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  handleCancel(){
    this.props.closeKrRightPane(false,this.props.item.id ? this.props.item.id : '')
  }
  validateAsanaKrCompleted(callback = null, data = {}) {
	if (callback && typeof callback === 'function') {
	  callback(data);
	} else {
		this.props.closeKrRightPane(true);
	}
  }

	validateAsanaKr(callback = null) {
		const {t} = this.props;
		let errors = {};
		let selAsanaProjIds = this.state.asanaProjIds;
		let selAsanaProjNames = this.state.asanaProjNames;
		let exclude;
		this.isSaveCustom(this.state.customInputData)
		this.setState({isCustomSave:[]})
	
		if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
			errors["customokr"] = t(`Please enter required field`);
			this.setState({isCustomSave:this.state.isRequirdCustomOkr})
		}
		if(document.getElementById("exclude_objective_asana")){
			exclude = document.getElementById("exclude_objective_asana").checked;
		}else{
			exclude = false;
		}
		if (selAsanaProjIds.length == 0) {
			errors["projSel"] = true;
		}
		//let metricName = $("#metric-name-text").val();
		let metricName = this.props.krText;
		if (
			typeof metricName === "undefined" ||
			metricName == null ||
			metricName == ""
		) {
			errors["metricName"] = true;
			this.props.showMetricNameErr();
		}
		if (Object.keys(errors).length) {
			this.setState({ errors });
		} else {
			if(this.props.item.source != 8 && this.props.item.source == 1){        
				this.setState({
					externalSource: true ,       
					titleRetain: "",
					contentRetain: "",
				})
			} else if ((this.props.item.source != 8 || (this.props.item.source == 8 && this.props.item.ext_app_id!=6)) && this.props.addEditFlag) {
				this.setState({
					confirmPopup : true
				})
			} else {
				let params = {};
				let _this = this;
				params.ext_source_name = metricName;
				//params.description = $("#metric-name-note").val();
				params.description = this.props.krNote;
				params.project_ids = selAsanaProjIds;
				params.project_names = selAsanaProjNames;
				params.ext_app_id = "6";
				params.source = "8";
				params.real_owner = this.props.realOwner.id;
				let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			    params.coOwners = coOwners.length > 0 ? Array.prototype.map
			     .call(coOwners, s => s.id)
			     .toString() : '';
				params.progress_consider = exclude == true ? 0 : 1;
				if (this.props.item && this.props.item.id) {
					params.id = this.props.item.id;
				}
				let teaMperArr = [], bizPerArr = [];
				if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
					const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
					if (Array.isArray(permission_teams) && permission_teams.length) {
						teaMperArr = permission_teams.map(val => val.id);
					}
					if (Array.isArray(permission_biz) && permission_biz.length) {
						bizPerArr = permission_biz.map(val => val.id);
					}
				} else {
					teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
					bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
				}
				params.permission_teams = teaMperArr;
				params.permission_biz = bizPerArr;

				if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
					params.permission = this.props.goalDetails.permission;
				} else {
					params.permission = Array.prototype.map
						.call(this.state.permissionstate, s => s)
						.toString(); // "A,B,C";
				}
				let krAlignSel = this.state.krAlingSelected;
				let dependentKrsSel = this.state.krDependenciesSelected;
				let krAligns = [];
				let dependentKrs = [];

				if (Object.keys(krAlignSel).length > 0) {
					krAlignSel.map(item => {
						krAligns.push(item.id);
					});
				}

				if (Object.keys(dependentKrsSel).length > 0) {
					dependentKrsSel.map(item => {
						dependentKrs.push(item.id);
					});
				}
				params["nested_krs"] = constructNestedKRPayload(this.props);
				params.krAligns = krAligns;
				let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
				let tagids=this.state.tags.length ? this.state.tags : ['']
				let finalTagsIds = [...nlpIds,...tagids]
				params.krTagIds = finalTagsIds;
				params.dependentKr = dependentKrs;
				let goalId = this.props.goalDetails.id;
				let { actions } = this.props;
				if (this.props.isChildKr && this.props.fromParentKr) {
					params.duration = this.props.childKrDuration;
					params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
					params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
					params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
					if(this.props.item.parent) {
						params.parent = this.props.item.parent;
					}
					this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
				} else if (this.props.mitChildKr){
					params.duration = this.props.childKrDuration;
					params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
					params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
					params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
					params.end_date = this.props.item.end_date;
					params.start_date = this.props.item.start_date;
					params.asanaProjIds = this.state.asanaProjIds;
					params.name = metricName;
					this.props.saveQuarterlyKR(params, this.props.mitIndex);
					this.validateAsanaKrCompleted(callback, params);
					// this.props.closeKrRightPane();
				} else {
					if (this.props.item.parent) {
						params.start_date = this.props.childKrDuration.start ;
						params.end_date = this.props.childKrDuration.end;
						params.parent = this.props.item.parent;
					}
			
					params.isQuarter  =this.props.isQuarter;
					params.kr_duration =this.props.kr_duration;
					params.customField=JSON.stringify(this.props.customFieldsData);
					reactLoader(true);
					this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
						response => {
							removeReactLoader();
							if (response.data) {
								if (!this.props.onlyMetEdit) {
									let result = response.data.data;
									let krWeightage = null;
									if (result.krWeightage) {
										krWeightage = result.krWeightage;
										delete result['krWeightage'];
									}
									if(result.parent){
										actions.addUpdateNestedKr(result)
									} else {
										actions.addNewKr(result);
									}
									
									if (krWeightage) {
										_this.props.MetricChangeWeight(krWeightage);
									}
								}
								this.validateAsanaKrCompleted(callback, response.data.data);
								// _this.props.closeKrRightPane(true);
								// this.GoalServices.triggerGoalMetricDetails({goalId});
							}
						}
					);
				}
			}
		}
	}

	exitDeleteModal() {
		this.setState({confirmPopup: false, externalSource : false });
	}

	saveItems() {
		let errors = {};
		let selAsanaProjIds = this.state.asanaProjIds;
		let selAsanaProjNames = this.state.asanaProjNames;
		let exclude;
		if(document.getElementById("exclude_objective_asana")){
			exclude = document.getElementById("exclude_objective_asana").checked;
		}else{
			exclude = false;
		}
		if (selAsanaProjIds.length == 0) {
			errors["projSel"] = true;
		}
		// let metricName = $("#metric-name-text").val();
		let metricName = this.props.krText;
		if (
			typeof metricName === "undefined" ||
			metricName == null ||
			metricName == ""
		) {
			errors["metricName"] = true;
			this.props.showMetricNameErr();
		}
		if (Object.keys(errors).length) {
			this.setState({ errors });
		} else {
			let params = {};
			let _this = this;
			params.ext_source_name = metricName;
			params.isQuarter  = this.props.isQuarter;
			params.kr_duration = this.props.kr_duration;
			params.description = $("#metric-name-note").val();
			params.project_ids = selAsanaProjIds;
			params.project_names = selAsanaProjNames;
			params.ext_app_id = "6";
			params.source = "8";
			params.real_owner = this.props.realOwner.id
			let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			params.coOwners = coOwners.length > 0 ? Array.prototype.map
			 .call(coOwners, s => s.id)
			 .toString() : '';
			params.progress_consider = exclude == true ? 0 : 1;
			if (this.props.item && this.props.item.id) {
				params.id = this.props.item.id;
			}
			let teaMperArr = [], bizPerArr = [];
			if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
				if (Array.isArray(permission_teams) && permission_teams.length) {
					teaMperArr = permission_teams.map(val => val.id);
				}
				if (Array.isArray(permission_biz) && permission_biz.length) {
					bizPerArr = permission_biz.map(val =>val.id);
				}
			} else {
				teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
				bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
			}
			params.permission_teams = teaMperArr;
			params.permission_biz = bizPerArr;

			if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
				params.permission = this.props.goalDetails.permission;
			} else {
				params.permission = Array.prototype.map
					.call(this.state.permissionstate, s => s)
					.toString(); // "A,B,C";
			}
			let krAlignSel = this.state.krAlingSelected;
			let dependentKrsSel = this.state.krDependenciesSelected;
			let krAligns = [];
			let dependentKrs = [];

			if (Object.keys(krAlignSel).length > 0) {
			  krAlignSel.map(item => {
				krAligns.push(item.id);
			  });
			}

			if (Object.keys(dependentKrsSel).length > 0) {
			  dependentKrsSel.map(item => {
				dependentKrs.push(item.id);
			  });
			}
			params["nested_krs"] = constructNestedKRPayload(this.props);
			params.krAligns = krAligns;
			params.krTagIds = this.state.tags.length ? this.state.tags : [''];
			params.dependentKr = dependentKrs;
			params.retainUpdates = this.state.selectedType ? this.state.selectedType : '' ;
			params.customField = JSON.stringify(this.props.customFieldsData);
			let goalId = this.props.goalDetails.id;
			let { actions } = this.props;
			if(this.props.isChildKr && this.props.fromParentKr){
				params.duration = this.props.childKrDuration;
				params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        		params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
				params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
				if(this.props.item.parent){
					params.parent = this.props.item.parent;
				}
				this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
			} else if(this.props.mitChildKr){
				params.duration = this.props.childKrDuration;
				params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
				params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
				params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
				params.end_date = this.props.item.end_date;
          		params.start_date = this.props.item.start_date;
				params.asanaProjIds = this.state.asanaProjIds;
				params.name = metricName;
				this.props.saveQuarterlyKR(params, this.props.mitIndex);
				this.props.closeKrRightPane();
			} else{
				if(this.props.item.parent){
					params.start_date = this.props.childKrDuration.start ;
					params.end_date = this.props.childKrDuration.end;
					params.parent = this.props.item.parent;
				}
				
				params.isQuarter  =this.props.isQuarter;
				params.kr_duration =this.props.kr_duration;
				params.customField=JSON.stringify(this.props.customFieldsData);
				reactLoader(true);
				this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
					response => {
						removeReactLoader();
						if (response.data) {
							this.setState({confirmPopup: false , externalSource : false });
							if (!this.props.onlyMetEdit) {
								let result = response.data.data;
								let krWeightage = null;
								if (result.krWeightage) {
									krWeightage = result.krWeightage;
									delete result['krWeightage'];
								}
								if(result.parent){
									actions.addUpdateNestedKr(result)
								}else{
									actions.addNewKr(result);
								}
								if (krWeightage) {
									_this.props.MetricChangeWeight(krWeightage);
								}
							}
							_this.props.closeKrRightPane(true);
							// this.GoalServices.triggerGoalMetricDetails({goalId});
						}
					}
				);
			}
		}
	}

	saveAlignArr(alignData){
		this.setState({
		  krAlingSelected: alignData
		})
	}
	saveDependentArr(dependentData){
		this.setState({
		  krDependenciesSelected: dependentData
		})
	}
	saveTag = (childData) =>{
		this.setState({tags:childData})
	}
	changeRadio(value) {
		const valueToSet = value
		this.setState(
		  {
			selectedType: valueToSet
		  }
		)
	}
	handleExcludeChange = () =>{
		this.setState({
			exclude: !this.state.exclude,
		})
	}

	isSaveCustom(isVal){
		let arr=[];
		let j=0;
		let keyArrCategory=[]
		let valArray = []
		isVal && Object.keys(isVal).forEach((v)=>{
		  j++;
		  isVal[v]["customFields"]&&
		  Object.keys(isVal[v]["customFields"]).forEach(objv=>{
			keyArrCategory.push(objv)
			if(isVal[v]["customFields"][objv]['is_required']=='1'
			&&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
			){
				 arr.push(objv,v)
				}
			if(isVal[v]["customFields"][objv]["text"]){
			  valArray.push(isVal[v]["customFields"][objv]["text"])
			}else{
			  valArray.push('')
			}   
		  })
		  if(j==Object.keys(isVal).length){
			this.setState({isRequirdCustomOkr:[...arr]})
		  }  
		  let finalDataArray=[]
		  for(let i=0;i<valArray.length;i++){
			if(Array.isArray(valArray[i])){
			  valArray[i].forEach(val => {
				finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
			  })
			}
			else{
			  finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
			}
			 
		  }
		  const tempData=finalDataArray
		})
		
	  }
	
	  isRequiredCustomOkrFiled(isVal,id){
		let cust_id=this.state.isCustomSave.find((u) => u == id);
		let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
		let fr= ar.filter(
			(u) => u != cust_id
		  )
		this.setState({isCustomSave:fr})
		this.isSaveCustom(isVal)
		this.setState({customInputData:isVal})
	  }
	
	  renderError(field) {
		return (
		  <ErrorTextComp key={field} errors={this.state.errors} field={field} />
		);
	  }
	

	updateTags(Newtags){
		this.setState({
		  selectednlplTagsName: Newtags
		})
	}
	render() {
		let errors = this.state.errors;
		let isErrors = Object.keys(errors).length;
		let defChecked = false;
		if (Object.keys(this.props.item).length > 0 && this.props.item.ext_app_id == '6' && this.props.kpiType == 'asa') {
			if (this.props.item.progress_consider == "0" || this.props.item.progress_consider == false) {
				defChecked = true;
			}
		}
		const {t} = this.props;
		const {exclude} = this.state;
		return (
			<div className="asana_kr">
				<div className="asana-select-proj">
					{t('Select which projects you want to measure')}
          			<span className="colorTheStar">*</span>
				</div>
				<div className="AsanaRepoCheckboxContainer">
					{this.state.asanaRepoData.length > 0 &&
						this.state.asanaRepoData.map((item, index) => (
							<CheckBoxComp
								id={"jiraSelectAnd" + item.project_id}
								label={item.project_name}
								onChange={(e) => this.changeRepoSelection(e, item)}
								checkboxProps={{
									defaultChecked: this.state.asanaProjIds.includes(
										item.project_id
									)
										? true
										: false
								}}
								classDefined={"asanaLable"}
								labelStyle={{
									verticalAlign: "top",
								}}
								subclassDefined={"asanaChecboxkWrap"}
							/>
						))}
				</div>
				{isErrors && typeof errors["projSel"] !== "undefined" ? (
					<div className="dsErr">{t('Select a project')}</div>
				) : (
						""
					)}
					 {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
            {  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&& 
                    <Customokr
											customData={this.props.customData}
											isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
											onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
											customFiledRequired={true}
											renderError={this.renderError}
											isCustomSave={this.state.isCustomSave}
										/>
            }
				{
					!this.props.isChildKr && !this.props.mitChildKr &&
					<div className="breakline" />
				}
				{    
					(this.props.addOkrData.display_nested_kr && 
					!this.props.isChildKr && !this.props.mitChildKr &&
					Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
					<NestedInlineComp
					{...this.props}
					actions = {this.props.actions}
					nested_krs = {this.props.nested_krs}
					updateNestedKrs = {this.props.updateNestedKrs}
					/>
				}
				<AddFinancialTargetsButton objectType="kr" objectId={props.item?.id} ownerUserId={props.realOwner?.id} />
				{!props.mitChildKr && <KrRelationshipWrapper {...props } metric={props.item} saveKr={this.validateAsanaKr}/>}
				{
					!this.props.isChildKr && !this.props.mitChildKr &&
					<>
						<KrAlignDependance {...this.props}
						saveDependentArr={this.saveDependentArr}
						saveAlignArr={this.saveAlignArr}
						krAlingArr={this.props.item.kr_aligns}
						krDependenciesArr={this.props.item.kr_dependent}
						/>
						 <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
						 nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
						 />
						<div className="fieldcontent jiraExclude">
							<ThemeProvider>
								<StyledCheckbox
									id="exclude_objective_asana"
									isChecked={exclude}
									label={t(`Exclude from objective progress calculation`)}
									onChange={this.handleExcludeChange}
								/>
							</ThemeProvider>
						</div>
					</>
				}
				
				{this.props.goalDetails && this.props.goalDetails.all_metrics == "0" && !this.props.mitChildKr ? (
					<div className="pT10">
						<div className="viewPermissionArea">
							<span>
								{t('View permissions in addition to')}{" "}
								{this.props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
								<div className="metricTargetHelptext permissionHelpText"
									onMouseEnter={event => {
										this.setState({ permissionHelpPopUp: true });
									}}
									onMouseLeave={event => {
										this.setState({ permissionHelpPopUp: false });
									}}
								/>
								{this.state.permissionHelpPopUp && (
									<div className="basic-popup">
										{t(`You can give your whole organization permission to view your objective, or just your team and managers`)}
								</div>
								)}
							</span>
						</div>
						<div className="pB10">
							<PermissionComp
								{...this.props}
								teamPermissionData={this.teamPermissionData}
								bizPermissionData={this.bizPermissionData}
								permissionData={this.permissionData}
								hide={false}
							/>
						</div>
					</div>
				) : (
						""
					)}

				{
					this.state.confirmPopup &&
						<DeleteCommonModal
							exitDeleteModal={this.exitDeleteModal}
							deleteItems={this.saveItems}
							id=""
							title={t(`Save Key Result with New Data Type`)}
							deleteContentOne=""
							deleteContentSecondParam=""
							deletefirstTitle=""
							deleteContentSecond={t(`Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.`)}
							buttonText={t("Save")}
						/>

				}
				{
					this.state.externalSource  &&
					<RetainUpdateModal
							selectedType={this.state.selectedType}
							changeRadio={this.changeRadio}
							exitDeleteModal={this.exitDeleteModal}
							deleteItems={this.saveItems}
							titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type") }
							contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
						/>
				}
			</div>
		);
	}
}

export default withTranslation()(AsanaPostLogin);
